import { AvatarSquare, Subtitle } from '@/components/atoms';
import { Wrapper } from './Catogory.styled';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  src?: string;
  isActive?: boolean;
  onClick: () => void;
}

const Category = (props: IProps) => {
  const { src, isActive, children, onClick } = props;

  return (
    <Wrapper onClick={onClick}>
      <AvatarSquare src={src} alt="navigator" isActive={isActive} bgColor="#FAFAFA" />
      <Subtitle level={6} color="gray-800">
        {children}
      </Subtitle>
    </Wrapper>
  );
};

export default Category;
